'use client';

import Image from 'next/image';
import { motion } from 'framer-motion';
import { useIsDesktop } from '@/shared/lib/react/useIsDesktop';
import { Typography } from '@/shared/ui/atoms';
import * as S from './styles';

interface StrategyCardProps {
  index: number;
  keyword: string[];
  boldText: string;
  description: string;
}

const StrategyCard = ({ index, keyword, boldText, description }: StrategyCardProps) => {
  const baseImageUrl = process.env.NEXT_PUBLIC_BASE_IMAGE_URL;
  const isLg = useIsDesktop();
  const imageUrl = `${baseImageUrl}/medicontents/landing/strategy0${index + 1}${isLg ? '' : '-m'}.png`;
  const paddingBottom = isLg ? (index === 1 ? '3.438rem' : '1.875rem') : index === 2 ? '3.75rem' : '2.5rem';

  return (
    <motion.div
      initial={{ y: 55, opacity: 0 }}
      whileInView={{ y: 0, opacity: 1 }}
      viewport={{ once: true, amount: 0.25 }}
      transition={{ duration: 0.7, ease: 'easeOut', delay: 0 }}
      className={`${S.card} ${index === 0 ? 'mt-0' : 'mt-[-1.25rem]'} md:mt-0 last:rounded-b-none last:bg-none`}
      style={{ paddingBottom: paddingBottom }}
    >
      <div className={S.imageWrap}>
        <Image src={imageUrl} alt={`strategy-${index + 1}`} fill sizes="100vw" className={S.image} />
      </div>
      <div className={S.contentWrap}>
        <div className={S.keywordRow}>
          {keyword.map((item, i) => (
            <Typography key={`keyword-${i}`} as="span" className={S.keyword}>
              {item}
            </Typography>
          ))}
        </div>
        <Typography as="p" className={S.description}>
          <b>{boldText}</b>
          {description}
        </Typography>
      </div>
    </motion.div>
  );
};

export default StrategyCard;
